import React from 'react';
import './Button.scss';
import PropTypes from 'prop-types';


const Button = ({onClick, children, size, variant, disabled, type, className}) => {
    const fontSize = {
        small: 'subtitle-3',
        medium: 'subtitle-1',
        large: 'subtitle-1',
    };

    return (
        <button type={type} onClick={onClick} disabled={disabled} className={`v2-button ${variant} ${size} ${disabled && 'disabled'} ${fontSize[size]} ${className || ''}`}>
            {children}
        </button>
    );
};

Button.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

export default Button;
